<template>
  <div class="h-100">
    <settings-top-nav :selectedProfileKeyName="selectedMetadataProfileInfo.name"
      :componentname="selectedComponent"
      @changeToSelectedMetadataProfileTableComponent='changeToSelectedMetadataProfileComponent'
      :showAddProfileKeyButton="selectedComponent != 'add-screen-profile'">
    </settings-top-nav>
    <component :is="selectedComponent" v-bind="currentProperties"
    :selectedProfileKeyName="selectedMetadataProfileInfo.name"
    :page="page" :searchFilters="searchFilters"
    @pageSwitched="handlePaginationSwitch" @searchFiltersUpdated="handleSearchFilters"
      @changeToSelectedMetadataProfileTableComponent='changeToSelectedMetadataProfileComponent'
    @changeToSelectedProfileKeyComponent='changeToSelectedMetadataProfileComponent'></component>
  </div>
</template>

<script>

import AddScreenProfile from "./AddScreenProfile.vue"
import ShowScreenProfiles from "./ShowMetadataProfiles.vue"
import MetadataProfileInfo from "./ScreenProfileInfo.vue"
import settingsTopNav from "./HeaderBar.vue"

export default {
  name: "MetadataProfiles",
  data() {
    return {
      selectedComponent: ShowScreenProfiles,
      selectedMetadataProfileInfo: {},
      page:1,
      searchFilters:{
        type:'all'
      }
    };
  },
  provide() {
    return {
      changeSelectedComponent: this.changeSelectedComponent,
    };
  },
  components: {
    "add-screen-profile": AddScreenProfile,
    "metadata-screen-info": MetadataProfileInfo,
    "show-screen-profiles": ShowScreenProfiles,
    "settings-top-nav": settingsTopNav,
  },
  methods: {
    handlePaginationSwitch(pageNo){
      this.page = pageNo
    },
    handleSearchFilters(searchfilterVals){
      this.searchFilters = searchfilterVals;
    },
    changeToSelectedMetadataProfileComponent(compName, metadataProfileDetails) {
      this.selectedComponent = compName;
      this.selectedMetadataProfileInfo = metadataProfileDetails
    },
    showBinsTopNav() {
      let comps = [
        "add-screen-profile",
        "metadata-screen-info"
      ];
      if (comps.indexOf(this.selectedComponent) > -1) {
        return true;
      }
    }
  },
  computed:{
      currentProperties() {
      if (this.selectedComponent === "metadata-screen-info") {
        return { selectedMetadataProfileId : this.selectedMetadataProfileInfo._id};
      }
      else{
          return {}
      }
    },
  }
};
</script>

<style scoped>

</style>